import React, { useEffect, useState } from 'react';
import { Groupper, Button, Input, Field, Message } from 'react-frontier';
import { useBreadcrumbs } from '../hooks';
import API from '../API';
import Validator from '../Validator';
import moment from 'moment';

var TicketsReport = ()=>{
	var { setTitle } = useBreadcrumbs();
	var [startDate, setStartDate] = useState<number>(null);
	var [endDate, setEndDate] = useState<number>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>([]);

	useEffect(()=>{
		setTitle('Reporte de aforos');
	}, []);

	var downloadReport = async(setLoading: (l: boolean)=>void)=>{
		var { valid, prompts } = Validator({ startDate, endDate }, {
			startDate: [{ rule: 'number', label: 'Fecha inicio' }],
			endDate: [{ rule: 'number', label: 'Fecha fin' }]
		});
		setErrorPrompts(prompts);
		if(!valid) return;
		if(endDate <= startDate)return prompts.push('La fecha de fin debe ser mayor que la fecha de inicio');

		var dateStart = moment.unix(startDate).startOf('day').unix();
		var dateEnd = moment.unix(endDate).endOf('day').unix();

		setLoading(true);	
		API.downloadTicketsReport(dateStart, dateEnd).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado (TKT-SCH-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	return <div>
		<Groupper title='Reporte de aforos' width={500} style={{ marginTop: 20 }} actions={<>
			<Button text='Descargar' color='black' style={{ marginRight: 10 }} iconName='download' onClick={downloadReport} disabled={!startDate || !endDate}/>
		</>}>
			<Field amount={2}>
				<Input 
					label='Fecha de inicio' 
					value={startDate} 
					onChange={setStartDate}
					style={{ width: '100%'}}
					calendar={{ 
						date: moment().subtract(30, 'd').startOf('day').unix(), 
						mode: 'date', 
						format: 'DD/MM/YYYY' 
					}} 
				/>
				<Input 
					label='Fecha de fin' 
					value={endDate}
					style={{ width: '100%'}}
					onChange={setEndDate} 
					calendar={{ 
						date: moment().endOf('day').unix(), 
						mode: 'date', 
						format: 'DD/MM/YYYY' 
					}} 
				/>
			</Field>
			<Message list={errorPrompts} type={'error'} />
		</Groupper>
	</div>
}

export default TicketsReport;